/* Outrider Supply — theme behaviour */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal sections slowly as they scroll into view */
  function initReveal() {
    var items = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window) || reduceMotion) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Hero film: honour reduced motion, play/pause button */
  function initHeroFilm() {
    document.querySelectorAll('[data-hero-film]').forEach(function (root) {
      var video = root.querySelector('video');
      var btn = root.querySelector('[data-film-toggle]');
      if (!video) { if (btn) btn.hidden = true; return; }
      video.muted = true;
      video.setAttribute('playsinline', '');
      var setState = function (playing) {
        if (!btn) return;
        btn.setAttribute('aria-label', playing ? 'Pause background film' : 'Play background film');
        btn.querySelector('[data-icon-pause]').style.display = playing ? '' : 'none';
        btn.querySelector('[data-icon-play]').style.display = playing ? 'none' : '';
      };
      if (reduceMotion) { video.pause(); video.removeAttribute('autoplay'); setState(false); }
      else { var p = video.play(); if (p && p.catch) p.catch(function () { setState(false); }); setState(true); }
      if (btn) btn.addEventListener('click', function () {
        if (video.paused) { video.play(); setState(true); } else { video.pause(); setState(false); }
      });
    });
  }

  /* Mobile menu: close when a link is chosen, lock scroll while open */
  function initMobileMenu() {
    var menu = document.querySelector('[data-mobile-menu]');
    var toggle = document.querySelector('[data-menu-toggle]');
    if (!menu || !toggle) return;
    var set = function (open) {
      if (open) menu.setAttribute('open', ''); else menu.removeAttribute('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };
    toggle.addEventListener('click', function () { set(!menu.hasAttribute('open')); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }


  /* ---------- Slide-out cart ---------- */
  var Cart = {
    root: function () { return document.querySelector('[data-cart-drawer]'); },
    lastFocus: null,
    open: function () {
      var r = this.root(); if (!r) return;
      this.lastFocus = document.activeElement;
      r.classList.add('is-open'); r.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var panel = r.querySelector('.cart-drawer__panel'); setTimeout(function () { panel && panel.focus(); }, 50);
    },
    close: function () {
      var r = this.root(); if (!r) return;
      r.classList.remove('is-open'); r.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },
    render: function (html) {
      var r = this.root(); if (!r || !html) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-cart-drawer]'); if (!fresh) return;
      var wasOpen = r.classList.contains('is-open');
      r.innerHTML = fresh.innerHTML; r.dataset.count = fresh.dataset.count;
      if (wasOpen) r.classList.add('is-open');
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = fresh.dataset.count; });
      var link = document.getElementById('CartLink'); if (link) link.setAttribute('aria-label', 'Bag, ' + fresh.dataset.count + ' items');
    },
    post: function (url, body) {
      body.sections = 'cart-drawer';
      body.sections_url = window.location.pathname;
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (res) { return res.json().then(function (data) { if (!res.ok || data.status) throw (data.description || data.message || 'Something went wrong'); return data; }); });
    },
    add: function (id, qty, props) {
      var self = this, item = { id: id, quantity: qty || 1 };
      if (props && Object.keys(props).length) item.properties = props;
      return this.post((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { items: [item] })
        .then(function (data) { self.render(data.sections && data.sections['cart-drawer']); self.open(); return data; });
    },
    change: function (line, qty) {
      var self = this, r = this.root();
      if (r) r.classList.add('is-busy');
      return this.post((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', { line: line, quantity: qty })
        .then(function (data) { self.render(data.sections && data.sections['cart-drawer']); })
        .catch(function (msg) { alert(msg); })
        .finally(function () { var r2 = self.root(); if (r2) r2.classList.remove('is-busy'); });
    }
  };
  window.OutriderCart = Cart;

  function initCart() {
    if (document.body.dataset.cartReady) return; document.body.dataset.cartReady = '1';
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-cart-toggle]') && Cart.root() && document.body.classList.contains('template-cart') === false) { e.preventDefault(); Cart.open(); return; }
      if (t.closest('[data-cart-close]')) { if (t.closest('a[href]') === null) e.preventDefault(); Cart.close(); return; }
      var q = t.closest('[data-qty-change]');
      if (q) { var li = q.closest('[data-line]'); Cart.change(Number(li.dataset.line), Number(q.dataset.qtyChange)); }
    });
    document.addEventListener('keydown', function (e) {
      var r = Cart.root(); if (!r || !r.classList.contains('is-open')) return;
      if (e.key === 'Escape') Cart.close();
      if (e.key === 'Tab') {
        var f = r.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCart();
    initReveal();
    initHeroFilm();
    initMobileMenu();
  });

  /* Re-run inside the theme editor when sections change */
  document.addEventListener('shopify:section:load', function () { initReveal(); initHeroFilm(); });
})();
